import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import { Typography } from '@material-ui/core'
import { ComparisonCta } from '../../../components/comparisonCta/ComparisonCta'
import { ProductComparisonCtaCardFragment } from '@gql'
import {Maybe} from "graphql/jsutils/Maybe";

export type ComparisonCtaTitleData  ={
    titleData: string | null | undefined
}

export type ComparisonCtaCardData = {
    cardData: ProductComparisonCtaCardFragment[]
}

const StyledCompCtaTitle = styled(Typography)`
  font-weight: 500;
  text-align: center;
  font-size: ${props => props.theme.typography.pxToRem(23)};
  margin: 0;
  width: 100%;
  
  ${props => props.theme.breakpoints.up('sm')} {
    margin-bottom: ${props => props.theme.typography.pxToRem(50)};
  }
    
  ${props=> props.theme.breakpoints.up('md')} {
    display: -webkit-box;
    -webkit-line-clamp: none;
    -webkit-box-orient: vertical;
    font-size: ${props => props.theme.typography.pxToRem(32)};
    padding-top: 0;
    line-height: ${props => props.theme.typography.pxToRem(45)};
  }
`
const getIconProps = (cardIcon: string | { icon?: Maybe<string>; variant?: Maybe<string> } | null | undefined) => {
    if (!cardIcon) return undefined;

    if (typeof cardIcon === 'string') {
        return { icon: cardIcon };
    }

    if (cardIcon.icon) {
        const validVariants = ['line', 'legacy', 'monotone', 'dualtone'] as const;
        return {
            icon: cardIcon.icon,
            variant: validVariants.includes(cardIcon.variant as any)
                ? (cardIcon.variant as typeof validVariants[number])
                : undefined
        };
    }

    return undefined;
};

export const ComparisonCtaComponent: React.FC<PropsWithChildren<ComparisonCtaTitleData & ComparisonCtaCardData>> = ({ titleData, cardData }) => (
  <>
    <StyledCompCtaTitle variant="h2">{titleData ? titleData : 'What\'s next'}</StyledCompCtaTitle>

    <ComparisonCta>
      {cardData?.map((card, index) => (
        <ComparisonCta key={index} card iconCode={getIconProps(card?.cardIcon)} title={card?.cardText || 'Learn more'} href={card?.cardLink?.url || ''}>
        </ComparisonCta>
      ))}
    </ComparisonCta>
  </>
)